import { isImperial } from "shared/utils/distanceUtils";

export const toMeters = (distance: number, unitOfDistance: server.dto.UnitsOfDistance) => {
  if (unitOfDistance === "metric") {
    return distance * 1000;
  }

  return Math.round(distance * 1609.344);
};

export const formatDistance = (distanceInMeters: number, locale: string) => {
  if (isImperial(locale)) {
    const miles = distanceInMeters / 1609.344;
    return `${Math.round(miles * 100) / 100} mi`;
  }

  // default to metric
  const kilometers = distanceInMeters / 1000;
  return `${Math.round(kilometers * 100) / 100} km`;
}